import React from "react";
import queryString from "query-string";
import AuthUserContext from "./auth-user-context";
import PartnerContext from "./partner-context";
import firebase from "../firebase";

const withAuthentication = Component =>
  class WithAuthentication extends React.Component {
    _isMounted = false;
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
        origin: "",
        queryParams: {}
      };
    }

    componentDidMount() {
      //localStorage.clear(); //for program_id
      //console.log("withAuthentication -> componentDidMount called...");
      this._isMounted = true;
      const auth = firebase.auth();
      this.listener = auth.onAuthStateChanged(authUser => {
        if (this._isMounted) {
          authUser
            ? this.setState({ authUser })
            : this.setState({ authUser: null });
        }
      });

      // const origin = document.referrer.includes("braingroom")
      //   ? "partner"
      //   : "home";
      //for testing partner access locally
      // const origin = window.location.hostname.includes("localhost")
      //   ? "partner"
      //   : "home";

      // this.setState({ origin }, () =>
      //   console.log("withAuthentication -> origin: ", this.state.origin)
      // );
      //this.setState({ origin });
      // console.log("href: ", window.location.href);
      // console.log("search: ", window.location.search);
      // const qp = queryString.parse(window.location.search);
      // console.log("qp: ", JSON.stringify(qp));
      const tmp = window.location.href.split("?"); //returns an array splitting the string before and after "?"
      const qp = queryString.parse(tmp[1]); //get position 1 in array for query string
      //console.log("qp2: ", JSON.stringify(qp2));
      this.setState({
        queryParams: { userID: qp.user_id, programID: qp.program_id }
      });
      const origin =
        document.referrer.includes("braingroom") || Object.keys(qp).length !== 0
          ? "partner"
          : "home";

      // to simulate partner
      // const origin =
      //   window.location.hostname.includes("localhost") ||
      //   Object.keys(qp).length !== 0
      //     ? "partner"
      //     : "home";
      // console.log("withAuthentication -> origin: ", origin);
      this.setState({ origin });

      //console.log("uid: ", qp.user_id + "-" + this.genUid() + "-" + Date.now());
    }

    componentWillUnmount() {
      //console.log("unmount -> going to execute listener()");
      this._isMounted = false;
      this.listener && this.listener();
    }

    // genUid = () => {
    //   return window.crypto.getRandomValues(new Uint32Array(1))[0];
    // };

    render() {
      const { authUser, origin, queryParams } = this.state;
      return (
        // <AuthUserContext.Provider value={authUser}>
        //   <Component {...this.props} />
        // </AuthUserContext.Provider>
        <AuthUserContext.Provider value={authUser}>
          <PartnerContext.Provider value={origin}>
            <Component {...this.props} />
          </PartnerContext.Provider>
        </AuthUserContext.Provider>
      );
    }
  };

export default withAuthentication;
